import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Space } from 'antd';
import moment from 'moment';

import ContainerArticles from 'modules/Media/components/ContainerArticles';
import MediaFilters from 'modules/Media/components/MediaFilter';

import {
  ArticleFilter,
  ArticleFilterAPI,
  formatArticleFilterAPI,
  useArticles
} from 'apiTyped/hooks/articles';
import get from 'lodash/get';

import {
  COOKIE_ARTICLES_FILTER_PAGE,
  COOKIE_ARTICLES_FILTER_FILTERS
} from 'config';

export const ArticleList = () => {
  const getInitalFilterValue = () => {
    const filters = sessionStorage.getItem(COOKIE_ARTICLES_FILTER_FILTERS);
    if (filters) {
      return {
        ...JSON.parse(filters),
        fromDate: moment(JSON.parse(filters).fromDate),
        toDate: moment(JSON.parse(filters).toDate)
      };
    }
    return {
      fromDate: moment().subtract(5, 'months'),
      toDate: moment(),
      page: 1
    };
  };

  const getInitalPageNumber = () => {
    const page = sessionStorage.getItem(COOKIE_ARTICLES_FILTER_PAGE);
    if (page) {
      return parseInt(page);
    }
    return 1;
  };

  const [filterValue, setFilterValue] =
    useState<ArticleFilter>(getInitalFilterValue);
  const [page, setPage] = useState(getInitalPageNumber);

  const filters: ArticleFilterAPI = useMemo(
    () => formatArticleFilterAPI({ ...filterValue, page }),
    [filterValue, page]
  );
  const { articlesResponse, isLoadingArticles } = useArticles(filters);

  const total_pages = get(articlesResponse, 'total_pages', 0);

  const handleFilterChange = (newFilter: ArticleFilter) => {
    // Save filters to session storage
    // so we reload them if we navigate back to the page from an article
    if (!newFilter) return;
    setFilterValue(newFilter);
    setPage(1);
  };

  const handlePrevious = () => {
    if (page === 1) return;
    setPage(page - 1);
  };

  const handleNext = () => {
    if (page === total_pages) return;
    setPage(page + 1);
  };

  useEffect(() => {
    sessionStorage.setItem(
      COOKIE_ARTICLES_FILTER_FILTERS,
      JSON.stringify(filterValue)
    );
  }, [filterValue]);

  useEffect(() => {
    sessionStorage.setItem(COOKIE_ARTICLES_FILTER_PAGE, page.toString());
  }, [page]);

  return (
    <Fragment>
      <Space direction="vertical" size="large" style={{ display: 'flex' }}>
        <MediaFilters
          filterValue={filterValue}
          onFilterChange={handleFilterChange}
        />
        <ContainerArticles
          articles={get(articlesResponse, 'results', [])}
          count={get(articlesResponse, 'count', 0)}
          isLoading={isLoadingArticles}
          filterOption={{ ...filterValue, page }}
          page={page}
          totalPages={total_pages}
          handlePrevious={handlePrevious}
          handleNext={handleNext}
        />
      </Space>
    </Fragment>
  );
};
